module.exports = __webpack_public_path__ + "static/media/visa.29548109.svg";